import { Modal } from "react-bootstrap";
import ContactUs from "../ContactUs/ContactUs";
import "./ContactUsModal.scss";

const ContactUsModal = ({ show, onHide }) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    size="xl"
    scrollable
    className="contact-us-modal"
    aria-labelledby="contact-us-modal-title"
  >
    <Modal.Header closeButton>
      <Modal.Title id="contact-us-modal-title">Contact us</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ContactUs variant="modal" />
    </Modal.Body>
  </Modal>
);

export default ContactUsModal;
